export default "__VITE_ASSET__c448bf84__"